import '../styles/style.scss';

import { ApolloProvider } from '@apollo/client';
import theme from '@bnnvara/themes';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';

import { NPOEventProvider } from '../context/NPOVideoPlayerContext';
import { apolloClient } from '../graphql/apolloClient';
import { MediaDataQuery } from '../graphql/MediaDataQuery';
import { NPOVideoPlayer } from '../NPOVideoPlayer/NPOVideoPlayer';

export const App = ({ location }) => {
  const [id, setId] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // this creates a new object based on the query string in the URL
    // so we can retrieve the parameters we need to load the app.
    const { search } = location;
    const searchParams = new URLSearchParams(search);
    const userIdParam = searchParams.get('user');

    /**
     * if param is not filled, it returns null in a string
     */
    if (userIdParam !== 'null') {
      setUser(searchParams.get('user'));
    }

    setId(searchParams.get('id'));
  }, [id, user, location]);

  // Provide an error when there is no id in the current state.
  // Could have a better layout or message :)
  if (!id) {
    return <p style={{ textAlign: 'center' }}>Please provide an `id`.</p>;
  }

  // This root component has an <ApolloProvider/> that allows us to do
  // GraphQL queries and mutations.
  // Nested within this component is a <MediaDataQuery/> which will fetch
  // the video data required for the <VideoPlayer/>. Note that the <VideoPlayer/>
  // itself is not loading the data so it can be used as a standalone player.
  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={theme.bnnvara}>
        <NPOEventProvider>
          <MediaDataQuery
            id={id}
            userId={user}
            render={(data) => React.createElement(NPOVideoPlayer, data)}
          />
        </NPOEventProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
};

App.propTypes = {
  // Location object from React Router
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};
